import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

const CustomCalender: React.FC = () => {
  const [currentMonth, setCurrentMonth] = useState<string>('January 2025');

  useEffect(() => {
    const value = new Date();
    const month = value?.toLocaleString('default', { month: 'long', year: 'numeric' });
    setCurrentMonth(month)
  }, []);
  
  const wrapperStyle: React.CSSProperties = {
    width: '100px',
    border: `1px solid`,
    fontSize: '12px',
    fontFamily: 'Arial, Verdana, sans-serif',
    textAlign: 'center'
  };

  return (

    <div style={wrapperStyle} className='mt-5'>
        <div className='bg-red-600 text-white'><span>{currentMonth}</span></div>
      
        <Calendar
            view="month"
            formatShortWeekday={() => ''}
            showNavigation={false} 
            showNeighboringMonth={false}
            tileDisabled={() => false}
        />
      <style>
        
      </style>
    </div>
  );
};

export default CustomCalender;